import { render, staticRenderFns } from "./contact-info.vue?vue&type=template&id=b9de338e&scoped=true&"
import script from "./contact-info.vue?vue&type=script&lang=js&"
export * from "./contact-info.vue?vue&type=script&lang=js&"
import style0 from "./contact-info.vue?vue&type=style&index=0&id=b9de338e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9de338e",
  null
  
)

export default component.exports